import {
  useFormErrorNotification,
  useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type { CreateOneShopReturnToStoreStoreDto } from "../generated/schema";
import useInvalidateShop from "./use-invalidate-shop";

type UseCreateShopStoreParams = {
  shopId: string;
  onSettled?: (
    data: unknown,
    error: Error | null,
  ) => Promise<unknown> | unknown;
};

export default function useCreateShopStore({
  onSettled,
  shopId,
}: UseCreateShopStoreParams) {
  const invalidateShop = useInvalidateShop(shopId);
  const mutation = $api.useMutation("post", "/shops/{shopId}/return-to-store/stores");
  const successNotification = useFormSuccessNotification();
  const errorNotification = useFormErrorNotification();

  return useMutation({
    onSettled,
    onError: () => {
      errorNotification();
    },
    onSuccess: () => {
      invalidateShop();
      successNotification();
    },
    mutationFn: async (requestBody: CreateOneShopReturnToStoreStoreDto) => {
      return mutation.mutateAsync({
        params: { path: { shopId } },
        body: requestBody,
      });
    },
  });
}
